import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

import Stack1 from 'assets/Home/portfolio/stack1.avif';
import Stack2 from 'assets/Home/portfolio/stack2.avif';
import Stack3 from 'assets/Home/portfolio/stack3.avif';
import Stack4 from 'assets/Home/portfolio/stack4.avif';

const StackedScroll = () => {
    interface IStikyInfo {
        title: string;
        description: string;
        img: string;
    }

    const stikyInfo: IStikyInfo[] = [
        {
            title: 'Application',
            description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores, nesciunt.',
            img: Stack1
        },
        {
            title: 'Web',
            description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores, nesciunt.',
            img: Stack2
        },
        {
            title: 'Lorem ipsum, dolor',
            description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores, nesciunt.',
            img: Stack3
        },
        {
            title: 'Lorem ipsum, dolor',
            description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores, nesciunt.',
            img: Stack4
        },
    ]

    const StickyItem = ({ item }: { item: IStikyInfo }) => {
        const ref = useRef(null);
        const { scrollYProgress } = useScroll({
            target: ref,
            offset: ["start end", "end end"],
        });

        const opacity = useTransform(scrollYProgress, [0, 1], [-1.5, 1]);
        const scale = useTransform(scrollYProgress, [0, 1], [0.7, 1]);

        return (
            <motion.div
                ref={ref}
                className="top-30 tablet:top-40 sticky flex flex-col justify-end items-start mt-15 tablet:mt-0 tablet:p-4 rounded-2xl tablet:rounded-none w-full h-[850px] tablet:h-[550px] text-white cursor-pointer"
                style={{
                    background: `url(${item.img}) center/contain no-repeat`,
                    opacity: opacity,
                    scale: scale,
                }}
            >
            </motion.div>
        );
    }

    return (
        <div className={`h-[${(stikyInfo.length - 1 * 850) + 700}px] w-full tablet:px-0 tablet:mb-0`}>
            {
                stikyInfo.map((item: IStikyInfo, idx: number) => (
                    <StickyItem key={idx} item={item} />
                ))
            }
        </div>
    )
}

export default StackedScroll